<template>
  <div
    class="h-full w-full flex items-center justify-between text-app-color py-5 cursor-pointer"
    @mouseover="isHover = true"
    @mouseleave="isHover = false"
  >
    <div class="flex items-center">
      <img v-if="icon" class="w-20 h-20 mr-10" :src="require(`@/assets/images/icons/${icon}.png`)" alt="icon">
      <img v-else-if="icon === null" class="w-20 h-20 mr-10" src="@/assets/images/icons/purple_circle.png" alt="icon">
      <img v-else class="w-20 h-20 mr-10" src="@/assets/images/book.svg" alt="icon">
      <p class="text-14 truncate" :class="isHover ? 'max-w-250' : 'max-w-420'">{{ item.title }}</p>
      <p v-if="isHover && item.book && item.book.title" class="text-12 text-app-color ml-10 font-bold"><span class="mr-8">·</span>{{ item.book.title }}</p>
    </div>
    <div class="flex items-center">
      <p v-if="isHover" class="hidden lg:block text-11 text-grey-700 mr-5">Trashed on: {{ parseDate(item.deletedAt, 'DD-MM,YYYY') }} <span v-if="hasSize">- {{ fileSize }}</span></p>
      <ButtonModule
        :has-hover="true"
        prefix="icon-undo"
        class="text-app-color text-16 pr-3"
        @click="$emit('restore')"
      />
      <ButtonModule
        :has-hover="true"
        prefix="icon-delete"
        class="text-app-color text-16 pr-3"
        @click="$emit('delete')"
      />
    </div>
  </div>
</template>

<script>
import ButtonModule from '@/components/shared/form-controls/ButtonModule'
import { parseDate } from '@/plugins/filters'

export default {

  components: { ButtonModule },

  props: {
    icon: { type: String },
    item: { type: Object },
    size: { type: Number },
    hasSize: { type: Boolean }
  },

  emits: ['delete', 'restore'],

  data () {
    return {
      isHover: false
    }
  },

  computed: {
    fileSize () {
      if (this.size / 1024 / 1024 < 1) return `${(this.size / 1024).toFixed(0)}kb`
      return `${(this.size / 1024 / 1024).toFixed(2)}Mb`
    }
  },

  methods: {
    parseDate
  }
}
</script>
